<div class="ols-title"><app-sharedtekst [key]="'belangrijk'"></app-sharedtekst></div>

<ng-container *ngIf="(resultaten$ | async) as resultaten">
  <ng-container *ngIf="verz_er_ruit && verz_er_ruit.length > 0">
    <div *ngIf="verz_er_ruit.length == 1" [innerHTML]="verz_er_ruit"></div>
    <ul *ngIf="verz_er_ruit.length > 1" class="ols-ml">
      <li *ngFor="let regel of verz_er_ruit" [innerHTML]="regel"></li>
    </ul>
  </ng-container>
</ng-container>
<ng-container *ngIf="!postcodeAanwezig || !kenteken">
  <br>
  <div>{{vraagtitel}}</div>
</ng-container>

<div class="ols-break">
  <div class="ols-break-sluit"></div>
</div>

<ng-container *ngIf="postcodeAanwezig  && kenteken">
  <div class="ols-newquestion shb richtext">
    <h2>Jouw ruitschade in 3 stappen opgelost.</h2>
    <ol>
      <li>Maak voor je {{merkkenteken}} direct een afspraak bij één van onderstaande reparateurs.</li>
      <li>Geef je kenteken aan hen door. Zij zien of je ruitschade verzekerd is en melden de schade bij ons.</li>
      <li>Zij repareren of vervangen je ruit en regelen alle kosten direct met ons. Je betaalt alleen het eigen risico
        zelf aan de reparateur.</li>
    </ol>

    <div *ngFor="let hersteller of herstellers" class="shb__item"
      [ngClass]="{ 'hidden': !geenPreferred && !hersteller.preferred && !this.overigeTonen, 'first': hersteller.preferred, 'last': !hersteller.preferred }">
      <div class="shb__item-ta">
        <div class="shb__item-title">{{hersteller.naam}}</div>
        <div class="shb__item-afstand">{{hersteller.afstandFormat}}</div>
      </div>
      <div class="shb__item-mas">
        <!-- Als MERKDEALER dan: <div class="shb__item-md"><div class="icon ial-al_035"></div>Merkdealer</div> -->
        <div class="shb__item-a">
          <div class="shb__item-adres">
            <div class="icon ial-fu_001"></div>
            <div>{{hersteller.adres}}</div>
          </div>
        </div>
        <div class="shb__item-s">
          <div *ngIf="hersteller.sterren && hersteller.sterren.length" class="shb__item-sterren" [ngClass]="hersteller.sterren">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="shb__item-pcpl">
          <div class="icon"></div>
          <div>{{hersteller.postcodeplaats}}</div>
        </div>
      </div>
      <div class="shb__item-cntct">
        <div>
          <div class="icon ial-al_004"></div><a href="{{hersteller.googlemaps}}" target="_blank">Route</a>
        </div>
        <div *ngIf="hersteller.telefoonnummer && hersteller.telefoonnummer.length">
          <div class="icon ial-al_022"></div><a
            [href]="'tel:' + hersteller.telefoonnummer">{{hersteller.telefoonnummer}}</a>
        </div>
        <div *ngIf="hersteller.website && hersteller.website.length">
          <div class="icon ial-al_002"></div><a href="{{hersteller.website}}" target="_blank">Website</a>
        </div>
      </div>
    </div>

    <h2 *ngIf="overigeTonen && !geenPreferred" class="shb__overig">Andere reparateurs bij jou in de buurt.</h2>

    <div *ngIf="sterrenAanwezig" class="shb__footer">Deze beoordeling van onze reparateurs bepalen we op basis van
      prijs, kwaliteit, beoordeling door andere klanten en onze schade-experts.</div>

    <div class="vraag__actions">
      <div class="buttons-container buttons-left">
        <a class="button button--outline has-ripple" (click)="naarHerstellerTool()"
          id="ipoclick-btn-{{geefPazaProces()}}-kiezer-reparatie-op-andere-locatie">Reparatie in andere plaats</a>
      </div>
      <div *ngIf="!overigeTonenClicked && !geenPreferred" class="buttons-container buttons-right">
        <div class="button button--text down-icon buttons-right"
          (click)="overigeTonen = true; overigeTonenClicked = true"
          id="ipoclick-btn-{{geefPazaProces()}}-kiezer-bekijk-overige-reparateurs">Bekijk andere reparateurs</div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!postcodeAanwezig || !kenteken">
  <div class="ols-newquestion">
    <div class="ols-title"><app-sharedtekst [key]="'afspraak'"></app-sharedtekst></div>

    <ul class="ols-radio">
      <li *ngFor="let antwoord of vraag.antwoorden" (click)="onClickAntwoord(antwoord)"
        (keyup.Space)="onClickAntwoord(antwoord)" [ngClass]="[selectedId == antwoord.id ? 'selected' : '']"
        tabindex="0">
        <div class="circle">
          <div class="outer">
            <div class="inner"></div>
          </div>
        </div>
        <div class="ols-img-container">
          <img *ngIf="antwoord.icon" [src]="iconlocation(antwoord.icon)" />
        </div>
      </li>
    </ul>

    <div class="vraag__actions">
      <div class="buttons-container">
        <a class="button button--schade has-ripple" (click)="naarGlashersteller()"
          id="ipoclick-btn-{{geefPazaProces()}}-kiezer-start_glashersteller">{{geefTekstKnop()}}</a>
      </div>
    </div>
  </div>
</ng-container>